import React, { memo } from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import Text from "@components/AppText";
import { useSelector } from "react-redux";
import Wallet from "@assets/svg/Wallet";
import ATMCard from "@assets/svg/ATMCard";
import ATMCardV2 from "@assets/svg/ATMCardV2";
import Caret from "@assets/svg/Caret";
import colors from "@constants/color";
import { isSmallScreen } from "@constants/metrics";

const LeaderBankDetails = memo((props) => {
  const { user = {} } = useSelector((state) => state.auth);

  const {
    bank_details: {
      ifsc_code = "",
      account_number = "",
      bank_name = "",
      account_holder_name = "",
    },
  } = user || {};

  const containerWidth = isSmallScreen ? "90%" : "100%";

  return (
    <View style={styles.container}>
      {/* <View style={styles.showAsRow}>
        <Wallet />
        <View style={{ paddingLeft: 10 }}>
          <Text bold>Account Details</Text>
        </View>
      </View> */}

      {!ifsc_code && !account_number ? (
        <TouchableOpacity
          style={styles.accountAddContainer}
          onPress={() => {
            props.navigation.navigate("BankDetailsForm");
          }}
        >
          <View style={[styles.showAsRow, styles.centerAndStart]}>
            <View style={[styles.showAsRow, { alignItems: "flex-start" }]}>
              <ATMCard />
              <View style={{ paddingLeft: 10 }}>
                <Text
                  fontType="head3"
                  style={{ color: colors.black, paddingBottom: 10 }}
                >
                  अकाउंट ऐड करें
                </Text>
                <View style={{ width: containerWidth }}>
                  <Text
                    fontType="content1"
                    style={{ color: colors.lightBlack }}
                  >
                    आसानी से पेमेंट करने के लिए अकाउंट ऐड करें!
                  </Text>
                </View>
              </View>
            </View>
            <View style={{ marginTop: 5, marginRight: 10 }}>
              <Caret />
            </View>
          </View>
        </TouchableOpacity>
      ) : (
        <View style={styles.accountAddContainer}>
          <View style={[styles.showAsRow, styles.centerAndStart]}>
            <View style={[styles.showAsRow, { alignItems: "center" }]}>
              <ATMCardV2 />
              <View style={{ paddingLeft: 20 }}>
                <Text fontType="content1">
                  {account_number
                    .slice(0, -4)
                    .split("")
                    .map((v) => "X")
                    .join("")}
                  {account_number.slice(-4)}
                </Text>
              </View>
            </View>
            <TouchableOpacity
              onPress={() => {
                props.navigation.navigate("BankDetailsForm", {
                  mode: "edit",
                  bank_details: user.bank_details,
                });
              }}
              style={{ paddingHorizontal: 10, paddingVertical: 5 }}
            >
              <Text fontType="content1" bold style={{ color: colors.primary }}>
                Edit
              </Text>
            </TouchableOpacity>
          </View>
          <View style={{ paddingLeft: 40, paddingVertical: 10 }}>
            <Text fontType="content1" style={{ color: colors.lightBlack }}>
              {account_holder_name}
            </Text>

            <Text fontType="content1" style={{ color: colors.lightBlack }}>
              IFSC CODE: {ifsc_code}
            </Text>
            <Text fontType="content1" style={{ color: colors.lightBlack }}>
              {bank_name}
            </Text>
          </View>
        </View>
      )}
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    margin: 8,
    marginBottom: 0,
  },
  showAsRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  accountAddContainer: {
    backgroundColor: "#fff",
    borderRadius: 8,
    padding: 10,
    marginVertical: 10,
    elevation: 6,
  },
  centerAndStart: {
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
});

export default LeaderBankDetails;
